module.exports = __webpack_public_path__ + "static/media/back.03d7335d.svg";